import { BRAND } from "../../constants/brand";
// BlogDetailPage.jsx
import React from "react";
import { Row, Col, Avatar } from "antd";
import {
  FacebookFilled,
  TwitterSquareFilled,
  LinkedinFilled,
  LinkOutlined,
} from "@ant-design/icons";
import bannerImage3 from "../../assets/echoo.png";
import MainLayout from "../../components/layout/main-layout";
import styles from "./index.module.scss";

const EchoChambers = () => {
  return (
    <MainLayout>
      <div className={styles.blogDetailPage}>
        {/* Hero Banner */}
        <div
          className={styles.banner}
          style={{
            background: `url(${bannerImage3}) no-repeat center center/cover`,
          }}
        >
          <h1>Echo Chambers: The decline of diversity of thought</h1>
        </div>

        {/* Author & Content Layout */}
        <Row gutter={[32, 32]} className={styles.mainContent}>
          {/* Sidebar */}
          <Col xs={24} md={7}>
            <div className={styles.sidebar}>
              <div className={styles.authorBox}>
                <div className={styles.authorInfo}>
                  <Avatar size={64} src="https://i.pravatar.cc/150?img=3" />
                  <div className={styles.authorText}>
                    <h3>Seraphina Isabella</h3>
                    <p>Journalist & Culture Writer</p>
                  </div>
                </div>
              </div>
              <div className={styles.postHeader}>
                <div className={styles.topBorder} />
                <p className={styles.publishDate}>Published on May 29, 2025</p>
                <h1 className={styles.postTitle}>
                  Echo Chambers: The <br className={styles.mobileBreak} />
                  decline of diversity of thought
                </h1>
                <p className={styles.author}>By Seraphina Isabella</p>
              </div>
              <div className={styles.contents}>
                <h4>Contents</h4>
                <ul>
                  <li>
                    <a href="#letter">A letter from Harleen & Andrew</a>
                  </li>
                  <li>
                    <a href="#echo">
                      Echo Chambers: Digital Comfort, Mental Confinement
                    </a>
                  </li>
                  <li>
                    <a href="#history">
                      The Historical Cost of Ignoring Diverse Voices
                    </a>
                  </li>
                  <li>
                    <a href="#pop">
                      What Popular Culture Is Telling Us—If We’re Willing to
                      Listen
                    </a>
                  </li>
                  <li>
                    <a href="#built">
                      Why We Built The Buddyhood: A Home for Honest, Varied
                      Storiess
                    </a>
                  </li>
                  <li>
                    <a href="#imprint">
                      {BRAND.domainLabel}: A Safe Digital Space for Listening Without
                      Judgement
                    </a>
                  </li>

                  <li>
                    <a href="#path">
                      A Path Forward—One Page, One Post, One Conversation at a
                      Time
                    </a>
                  </li>
                  <li>
                    <a href="#references">References</a>
                  </li>
                </ul>
              </div>

              <div className={styles.share}>
                <h4>Share This Blog</h4>
                <div className={styles.icons}>
                  <FacebookFilled />
                  <TwitterSquareFilled />
                  <LinkedinFilled />
                  <LinkOutlined />
                </div>
              </div>
            </div>
          </Col>

          {/* Blog Content */}
          <Col xs={24} md={17}>
            {/* <div className={styles.contentArea}>
            <p className={styles.intro}>
              As a mixed-race couple from very different socioeconomic and
              cultural backgrounds...
            </p>

            <img
              src="https://images.unsplash.com/photo-1581090700227-1c65e7b2cfb1"
              alt="Brain in cage"
              className={styles.featureImage}
            />

            <section id="echo">
              <h2>Echo Chambers: Digital Comfort, Mental Confinement</h2>
              <p>
                Echo chambers offer a sense of validation and reinforcement...
              </p>
            </section>

            <section id="history">
              <h2>The Historical Cost of Ignoring Diverse Voices</h2>
              <p>
                History is filled with examples where minority voices were
                ignored...
              </p>
            </section>

            <section id="pop">
              <h2>
                What Popular Culture is Telling Us—We’re Willing to Listen
              </h2>
              <p>
                In today’s world, popular culture influences our understanding
                of societal norms...
              </p>
            </section>
          </div> */}
            <div className={styles.articleWrapper}>
              <p className={styles.intro} id="letter">
                <strong>
                  A letter from Harleen & Andrew, founders of The Buddyhood Ltd
                  and {BRAND.domainLabel}
                </strong>
              </p>

              <p>
                As a mixed-race couple from very different socioeconomic and
                cultural backgrounds we have always known that to survive and
                grow we must be respectful, tolerant and truly listen to one
                another. What we didn’t realise is that this is diversity of
                thought. On the face of it, we look different but in this
                digital world we don’t often know how someone looks; it’s how
                someone thinks, that drives our connections. 
              </p>

              <p>
                As we look deeper, we consider why did we choose to be with each
                other when we are so different? Differing opinions create
                conflict, and sure, we do have many arguments! However, it also
                fosters a forum for further learning and humility because you’ll
                never feel like you know everything. 
              </p>

              <p>
                Diversity of thought thrives when there is a heart that is full
                enough to care and a mind hungry enough to learn. This is how we
                as humans have developed and evolved and what will determine our
                survival. Yet, it is interesting that this fundamental fragment
                of our survival is at risk. Why are we as society choosing the
                opposite online?
              </p>

              <img
                src="/Images/brainworks.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              />

              <h2 id="echo">
                Echo Chambers: Digital Comfort, Mental Confinement
              </h2>
              <p>
                Today's social media platforms reward repetition, not
                reflection. The more you engage with one idea, the more of that
                idea you will see. This is no accident—this is by design.
              </p>
              <p>
                Personalisation isn't neutral—it's narrowing. A 2024 study by
                the Oxford Internet Institute found that algorithmic curation
                reduces exposure to opposing views by over 60% within just two
                weeks of regular use. That means our children, peers, and even
                ourselves, are no longer hearing the other side. We're simply
                seeing more of what we already believe.
              </p>
              <p>
                Mental health suffers in echo chambers.The same study reported a
                rise in anxiety, division, and extremism, especially among
                teens. Not because people are inherently cruel—but because
                they're trapped in loops where nuance doesn't exist. Where
                anyone who disagrees must be “cancelled” or “corrected”,
                otherwise they will face bullying and harassment.
              </p>

              <p>That's not growth. That's intellectual claustrophobia.</p>
              <h2 id="history">
                The Historical Cost of Ignoring Diverse Voices
              </h2>
              <p>This isn't just a modern problem.</p>
              <p>
                History is full of rulers who fell—not because they were
                overthrown by stronger enemies—but because they refused to
                listen to inconvenient truths.
              </p>
              <p>
                Think of King Louis XVI of France—so insulated by his court and
                echoing aristocracy that he failed to hear the cries of
                revolution until it was too late. Or Tsar Nicholas II of Russia,
                whose rejection of alternative perspectives within his own
                advisory circle contributed to the collapse of the Romanov
                dynasty.
              </p>
              <p>
                They weren't lacking in power. They were lacking in perspective.
              </p>
              <p>
                Without challenge, power becomes fragile. Without differing
                opinions, leadership becomes blind.
              </p>
              <p>
                Diversity of thought isn’t just a “nice to have”—it’s survival…
                yet today, we’re building our digital lives in the same way
                those doomed courts were built: with walls, not windows.
              </p>

              <h2 id="pop">
                What Popular Culture Is Telling Us—If We're Willing to Listen
              </h2>
              <p>
                We've seen glimmers of this explored in modern media. Programmes
                like Black Mirror warn us of worlds where every opinion is
                filtered, every voice rated, every action judged in real time.
                In the episode “Nosedive”, we watch a woman spiral—not because
                of cruelty, but because of curated approval that leaves no room
                for authenticity or challenge.
              </p>
              <p>
                In The Social Dilemma, real Silicon Valley designers confess how
                the platforms they helped build are fuelling division,
                misinformation and manipulation—all while monetising our mental
                fragility
              </p>
              <p>
                Each of these stories reminds us: echo chambers don’t just
                isolate. They mislead, and eventually, they break us.
              </p>

              <h2 id="built">
                Why We Built The Buddyhood: A Home for Honest, Varied Stories
              </h2>
              <p>This is why we write the way we do at The Buddyhood.</p>
              <p>
                Our books aren’t built around a single narrative or ideology.
                They explore grief, gender, family, culture, courage, and
                identity—from multiple angles. We intentionally include
                different characters, perspectives, and internal
                conflicts—because that’s how real life is. That’s how truth
                actually looks.
              </p>
              <p>
                Stories, when written with heart and breadth, become tools of
                empathy. They offer a safe way to explore thoughts we may not
                otherwise voice. They allow young people to ask:
              </p>
              <p>
                What if I don’t agree with this character? What does that mean
                about me?
              </p>
              <p>
                What if I see a bit of myself in someone I was taught to judge?
              </p>
              <p>
                When stories include diverse thinking, readers learn to hold
                space for it in their own lives.
              </p>

              <h2 id="imprint">
                {BRAND.domainLabel}: A Safe Digital Space for Listening Without
                Judgement
              </h2>
              <p>
                Of course, stories are just the beginning. We knew we needed a
                place where those thoughts could be shared—authentically,
                safely, and without performance pressure. A digital platform
                that replaced the walls for windows so that we could see how our
                online self creates impact in the real world.{" "}
              </p>
              <p>
                So, we created {BRAND.domainLabel}, a social platform built around
                human values.
              </p>
              <p>
                <strong> Pre-moderated for safety: </strong> The content is
                constructive not destructive. No status games. No trolls
              </p>
              <p>
                <strong> Expression without correction: </strong> Users post
                reflections tied to core values—like love, safety, laughter,
                purpose.
              </p>
              <p>
                <strong> Every voice counts: </strong> There are no followers.
                No comments. Just real voices sharing real thoughts.
              </p>
              <p>
                It’s a space where diversity of thought isn’t just allowed—it
                thrives, because when you remove judgement, comparison, and
                fear, people begin to share what they actually believe—not what
                they think will be applauded.
              </p>
              <p>
                In that moment, real empathy is born. The platform isn’t
                designed to be positive, it is designed to be honest and real,
                where the focus is on change and community, not clicks
              </p>

              <img
                src="/Images/manForward.png"
                alt="Brain in a cage"
                className={styles.featureImage}
              />
              <h2 id="path">
                A Path Forward—One Page, One Post, One Conversation at a Time
              </h2>
              <p>This is the world we’re trying to build.</p>
              <p>One where a boy can question masculinity without ridicule.</p>
              <p>
                Where a girl can explore her identity without being funnelled
                into stereotypes.
              </p>
              <p>
                Where parents and children can talk—not just about rules, but
                about reasons.
              </p>
              <p>
                We hope to empower educators, parents and young people to truly
                listen before reacting with the aim to seek insight, not just
                agreement. To not be afraid of difficult conversations—because
                they’ve seen them modelled in stories, and shared them, in safe
                digital spaces.
              </p>
              <p>
                Let’s remember that diversity of thought is what fuels real
                progress—not noise, not conformity, not popularity.
              </p>
               <p>
               Let’s build a world where more people say:
              </p>
             
              <blockquote>
                <p>
                  <em>I hadn’t thought of it that way before.</em>
                </p>
                <p>That’s the power of stories.</p>
                <p>That’s the power of perspective.</p>
                <p>That’s the power of you.</p>
              </blockquote>

              <p>
                <strong>— Harleen & Andrew</strong>
                <br />
                Founders of The Buddyhood Ltd and {BRAND.domainLabel}
              </p>

              <h3 id="references"> References</h3>
              <ul className={styles.references}>
                <li>
                  Oxford Internet Institute (2024). Algorithmic Isolation in
                  Personalised Digital Feeds
                </li>
                <li>
                  Centre for Data Ethics & Innovation (2024). Mental Health
                  Costs from Online Echo Chambers
                </li>
                <li>Netflix: Black Mirror – “Nosedive” (2016)</li>
                <li>Netflix: The Crown (Various Episodes)</li>
                <li>Netflix: The Social Dilemma (2020)</li>
              </ul>
            </div>
          </Col>
        </Row>
      </div>
    </MainLayout>
  );
};

export default EchoChambers;
